// Mock data for martial arts dojo landing page
import { galleryData } from './data/galleryData';

export const dojoData = {
  hero: {
    title: "L'Aïkido à Cahors: Grandir ensemble depuis 1984",
    subtitle: "Pour tous les âges et tous les niveaux : découvrez un art martial non-violent qui cultive confiance, respect et bien-être",
    cta: "Découvrez le club"
  },
  
  about: {
    title: "A PROPOS DE NOTRE DOJO",
    description: "Nous pratiquons un aïkido concret, sans mysticisme. Un art martial qui apprend à aborder les conflits de manière constructive plutôt que destructrice.",
    philosophy: "En aïkido, nous n'attaquons jamais. Une attaque ne fait que démontrer que vous êtes incertain de la victoire, que vous avez déjà été vaincu spirituellement [...] Nous gagnons parce que nous ne combattons pas ; telle est la valeur de l'aïkido...",
    styles: [
      {
        name: "Karate",
        description: "Traditional Shotokan Karate focusing on precise techniques and kata mastery"
      },
      {
        name: "Judo",
        description: "The gentle way - emphasizing throws, grappling, and ground techniques"
      },
      {
        name: "Aikido",
        description: "Harmonious martial art using opponent's energy through circular movements"
      }
    ],
    benefits: [
      "Coordination et conscience corporelle améliorées",
      "Gestion constructive des conflits et du stress",
      "Confiance en soi et assurance personnelle",
      "Amélioration de la posture et de la souplesse",
      "Développement de la concentration et de l'équilibre"
    ]
  },

  schedule: [
    {
      day: "Mardi",
      classes: [
        { time: "18:00 - 19:00", name: "Cours enfant", level: "Enfant", instructor: "Quentin POIRIER", locationId: "main" },
        { time: "19:00 - 20:00", name: "Cours débutant", level: "Débutant", instructor: "Quentin POIRIER", locationId: "main" },
        { time: "20:00 - 21:00", name: "Cours tous niveaux", level: "Tous niveaux", instructor: "Jean-Louis CHAUDESSOLLE", locationId: "main" }
      ]
    },
    {
      day: "Jeudi",
      classes: [
        { time: "18:30 - 19:45", name: "Cours tous niveaux", level: "Tous niveaux", instructor: "Quentin POIRIER", locationId: "main" },
      ]
    },
    {
      day: "Vendredi",
      classes: [
        { time: "20:30 - 22:00", name: "Cours confirmés", level: "Confirmé", instructor: "Jean-Louis CHAUDESSOLLE", locationId: "secondary" },
      ]
    }
  ],

  pricing: [
    {
      name: "Séances d'essai",
      price: "GRATUIT",
      duration: "Deux premiers cours",
      features: [
        "Aucun engagement",
        "Découvrez les dojos",
        "Rencontrez les pratiquants"
      ],
      popular: true,
      type: "trial"
    },
    {
      name: "Adhésion Adulte",
      price: "175€",
      duration: "par an",
      basePrice: "175€/an",
      quarterlyPrice: "65€/trimestre",
      federationFee: "38€/an",
      features: [
        "Accès à tous les cours adultes",
        "Progression selon votre rythme",
        "Armes fournies pendant les cours"
      ],
      popular: false,
      type: "adult"
    },
    {
      name: "Adhésion Enfant",
      price: "100€",
      duration: "par an (9-13 ans)",
      basePrice: "100€/an",
      federationFee: "26€/an",
      features: [
        "Cours adaptés à l'âge",
        "Développement coordination",
        "Techniques sécurisées"
      ],
      popular: false,
      type: "youth"
    }
  ],

  locations: [
    {
      id: "main",
      name: "Gymnase Henri-Thamier",
      address: "40 Rue de l'Île, 46000 Cahors",
      phone: "06 84 66 87 14",
      email: "contact@aikido-cahors.fr",
      coordinates: { lat: 44.453486, lng: 1.444128 },
      hours: {
        "Mardi": "18:00 - 21:00",
        "Jeudi": "18:30 - 19:45"
      },
      transportation: "Une navette peut vous déposer au parking de l'Archipel. Elle ne passe plus après les cours en revanche.",
      parking: "Des places de parking sont toujours disponibles aux heures de cours à côté des dojos."
    },
    {
      id: "secondary",
      name: "Complexe sportif",
      address: "150 Rue de la Guinguette, 46000 Cahors",
      phone: "06 84 66 87 14",
      email: "contact@aikido-cahors.fr",
      coordinates: { lat: 44.4555629, lng: 1.4458134 },
      hours: {
        "Vendredi": "20:30 - 22:00"
      },
      transportation: "Accessible en voiture, bus ligne 912 depuis Cahors.",
      parking: "Parking gratuit devant le complexe ainsi que dans le parking souterrain."
    }
  ],

  testimonials: [
    {
      name: "Sarah Johnson",
      text: "Training here has completely transformed my confidence and physical fitness. The instructors are incredibly patient and skilled.",
      rating: 5
    },
    {
      name: "Mike Chen",
      text: "My son has been training here for 3 years. The discipline and respect he's learned extends far beyond the dojo.",
      rating: 5
    },
    {
      name: "Elena Rodriguez",
      text: "As an adult beginner, I was nervous, but the welcoming community made me feel at home immediately.",
      rating: 5
    }
  ],

  gallery: galleryData,

  faq: [
    {
      question: "Que dois-je apporter pour mon premier cours ?",
      categories: ["Débuter l'Aïkido"],
      answer: "Juste des vêtements de sport confortables et une bouteille d'eau. Nous fournissons tout l'équipement nécessaire pour les débutants."
    },
    {
      question: "À partir de quel âge peut-on commencer ?",
      categories: ["L'Aïkido chez l'enfant"],
      answer: "Nous accueillons les enfants de 9 à 13 ans. Le programme est adapté à leur développement."
    },
    {
      question: "Comment assurez-vous la sécurité des enfants ?",
      categories: ["L'Aïkido chez l'enfant"],
      answer: "Nous priorisons l'apprentissage des chutes et mouvements de base avant les techniques. Les exercices sont adaptés à l'âge avec des variations sécurisées."
    },
    {
      question: "Quelles valeurs l'aïkido développe-t-il chez l'enfant ?",
      categories: ["L'Aïkido chez l'enfant"],
      answer: "Respect, confiance en soi, coordination, concentration et gestion du stress. L'aïkido aide particulièrement les enfants timides ou ayant des difficultés relationnelles."
    },
    {
      question: "Suis-je trop âgé(e) ou pas assez en forme pour commencer ?",
      categories: ["Débuter l'Aïkido"],
      answer: "L'aïkido convient à tous les âges et niveaux de forme physique. La pratique est basée sur la fluidité et la technique plutôt que la force brute. Nous accueillons régulièrement des débutants de 40, 50 ans et plus.",
    },
    {
      question: "À quoi dois-je m'attendre lors de mon premier cours ?",
      categories: ["Débuter l'Aïkido"],
      answer: "Mouvements de base et techniques simples. Vous serez guidé par des pratiquants expérimentés et bienveillants."
    },
    {
      question: "C'est quoi l'Aïkido ?",
      categories: ["Comprendre l'Aïkido"],
      answer: "L'aïkido est un art martial défensif qui enseigne à aborder un conflit avec un état d'esprit constructif plutôt que destructif. Il utilise des mouvements fluides, des projections et immobilisations."
    },
    {
      question: "C'est quoi la différence avec les autres arts martiaux ?",
      categories: ["Comprendre l'Aïkido"],
      answer: "L'aïkido se concentre uniquement sur la défense, il n'y a ni compétition, ni coups portés. L'objectif technique est la neutralisation sans blessure."
    }
  ]
};

export default dojoData;
